import { GET, POST, DELETE } from '@/axios';

export async function getMySubscription() {

    try {

        // skipAuthRedirect: obtener el plan es una operación de fondo no crítica.
        // Si falla con 401 (p. ej. al entrar a un tenant recién provisionado) NO debe
        // cerrar la sesión ni redirigir a la URL base; hydrate lo captura y hace fail-open.
        return await GET('my-subscription', { skipAuthRedirect: true });

    } catch (error) {

        console.error('Error al obtener mi suscripción:', error);
        throw error;

    }
}

export async function getMyQuotaUsage(params = {}) {

    try {

        return await GET('my-subscription/quota', { params });

    } catch (error) {

        console.error('Error al obtener mi consumo de cuota:', error);
        throw error;

    }
}

export async function getMyAddons(params = {}) {

    try {

        return await GET('my-subscription/addons', { params });

    } catch (error) {

        console.error('Error al obtener mis add-ons:', error);
        throw error;

    }
}

export async function contractMyAddon(data) {

    try {

        return await POST('my-subscription/addons', data);

    } catch (error) {

        console.error('Error al contratar add-on:', error);
        throw error;

    }
}

export async function cancelMyAddon(tenantAddonId, data = {}) {

    try {

        return await DELETE(`my-subscription/addons/${tenantAddonId}`, { data });

    } catch (error) {

        console.error('Error al cancelar add-on:', error);
        throw error;

    }
}

export async function getMyPlanHistory(params = {}) {

    try {

        return await GET('my-subscription/history', { params });

    } catch (error) {

        console.error('Error al obtener mi historial de plan:', error);
        throw error;

    }
}

export async function getAvailablePlans(params = {}) {

    try {

        return await GET('my-subscription/plans', { params });

    } catch (error) {

        console.error('Error al obtener planes disponibles:', error);
        throw error;

    }
}

export async function requestPlanChange(data) {

    try {

        return await POST('my-subscription/change-request', data);

    } catch (error) {

        console.error('Error al solicitar cambio de plan:', error);
        throw error;

    }
}

export async function getMyNotifications(params = {}) {

    try {

        return await GET('my-subscription/notifications', { params });

    } catch (error) {

        console.error('Error al obtener mis notificaciones:', error);
        throw error;

    }
}

export async function markNotificationRead(notificationId) {

    try {

        return await POST(`my-subscription/notifications/${notificationId}/read`, {});

    } catch (error) {

        console.error('Error al marcar la notificación como leída:', error);
        throw error;

    }
}
